var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.517,
    height: 83.205,
    viewBox: "0 0 199.517 83.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_ACA",
    "data-name": "Logo ACA",
    transform: "translate(-152.358 -627.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(152.358 627.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M175.991,738.471h5.637a.37.37,0,0,0,.338-.519l-11.756-26.673a.369.369,0,0,0-.338-.22h-5.389a.37.37,0,0,0-.338.22l-11.756,26.673a.37.37,0,0,0,.338.519h5.637a.37.37,0,0,0,.337-.218l2.272-5.048h12.408l2.272,5.048a.37.37,0,0,0,.337.218M163.408,727.8l3.77-8.376,3.77,8.376Z",
    transform: "translate(-152.358 -683.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M397.695,738.471h5.637a.37.37,0,0,0,.338-.519l-11.756-26.673a.369.369,0,0,0-.338-.22h-5.389a.37.37,0,0,0-.338.22l-11.756,26.673a.37.37,0,0,0,.338.519h5.637a.37.37,0,0,0,.337-.218l2.272-5.048h12.408l2.272,5.048a.37.37,0,0,0,.337.218M385.112,727.8l3.77-8.376,3.77,8.376Z",
    transform: "translate(-302.442 -683.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(18.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M243.4,638.219a30.581,30.581,0,0,1,24.476,12.214.371.371,0,0,0,.515.078l8.252-6.055a.37.37,0,0,0,.078-.519,41.607,41.607,0,0,0-66.643,0,.369.369,0,0,0,.078.519l8.252,6.055a.371.371,0,0,0,.515-.078A30.581,30.581,0,0,1,243.4,638.219",
    transform: "translate(-210.003 -627.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M243.4,824.936a30.581,30.581,0,0,1-24.476-12.214.37.37,0,0,0-.515-.078l-8.252,6.055a.369.369,0,0,0-.078.519,41.607,41.607,0,0,0,66.643,0,.37.37,0,0,0-.078-.519l-8.252-6.055a.37.37,0,0,0-.515.078A30.581,30.581,0,0,1,243.4,824.936",
    transform: "translate(-210.003 -752.705)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M272.191,726.844a12,12,0,1,1,9.462-19.39.368.368,0,0,0,.508.07l5.575-4.09a.37.37,0,0,0,.074-.524,19.654,19.654,0,1,0,0,23.862.371.371,0,0,0-.074-.525l-5.574-4.09a.369.369,0,0,0-.509.071,11.983,11.983,0,0,1-9.461,4.617",
    transform: "translate(-220.175 -673.238)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaLogo);
export default __webpack_public_path__ + "static/media/ACA-logo.c5ad0468fc7fd3d5a244bf299ef1da3b.svg";
export { ForwardRef as ReactComponent };